<template>
  <div
    class="row WPLayout"
    :class="{'noColumnPadding': !layoutData.column_padding, 'noPad': layoutData.acf_fc_layout == 'full_page_width'}"
    :style="styles"
  >
    <component :is="layoutData.acf_fc_layout" v-bind="layoutData"/>
  </div>
</template>

<script>
const FullWidth = () => import("./FullWidth");
const FullPageWidth = () => import("./FullPageWidth");
const Cols25_75 = () => import("./Cols-25-75");
const Cols75_25 = () => import("./Cols-75-25");
const Cols33_33_33 = () => import("./Cols-33-33-33");
const Cols50_50 = () => import("./Cols-50-50");
const Cols33_66 = () => import("./Cols-33-66");
const Cols66_33 = () => import("./Cols-66-33");
const Cols25_25_25_25 = () => import("./Cols-25-25-25-25");

export default {
  name: "BaseLayout",
  components: {
    //names must match layout name in wordpress
    full_width: FullWidth,
	full_page_width: FullPageWidth,
    "layout-25_75": Cols25_75,
    "layout-75_25": Cols75_25,
    "layout-33_33_33": Cols33_33_33,
    "layout-50_50": Cols50_50,
    "layout-33_66": Cols33_66,
    "layout-66_33": Cols66_33,
    "layout-25_25_25_25": Cols25_25_25_25
  },
  props: ["layoutData"],
  computed: {
    styles() {
      let stylesObj = {};

      let background = this.layoutData.background_colour;
      if (background) {
        stylesObj["background-color"] = background;
        switch (background) {
          case "white":
          case "#f0f0f0":
            stylesObj["color"] = "black";
            break;
          case "#b4343e":
            stylesObj["color"] = "white";
            break;
          default:
            stylesObj["color"] = "black";
            break;
        }
      }

      let padding = this.layoutData.padding;

      if (padding) {
        if (padding.left) {
          stylesObj["padding-left"] = padding.left + "px";
        }
        if (padding.right) {
          stylesObj["padding-right"] = padding.right + "px";
        }
        if (padding.top) {
          stylesObj["padding-top"] = padding.top + "px";
        }
        if (padding.bottom) {
          stylesObj["padding-bottom"] = padding.bottom + "px";
        }
      }

      return stylesObj;
    }
  }
};
</script>

<style lang="scss">
// Remove padding from columns inside this row

@include media-breakpoint-down(md){
	.WPLayout:not(.noPad){
		padding: 20px 20px !important;
	}
}

.noColumnPadding .row {
  margin-right: 0;
  margin-left: 0;
}
.noColumnPadding .row > [class*="col-"] {
  margin-left: 0;
  margin-right: 0;
  padding-left: 0;
  padding-right: 0;
}
</style>
